// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"65f2c85e993f30ef","5763":"1f737c817cd7d2c6","6893":"cccc143c64bfd9e2","6974":"6a4eede71204d3f9","7222":"c50bdb6c500178a6","7937":"63054d460911ed45"}[chunkId] + ".js";
};